// extracted by mini-css-extract-plugin
export default {"container":"aboutme_container__t539G","stuff":"aboutme_stuff__SP-1S","meFace":"aboutme_meFace__uhsH6"};